import { useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import GrainOverlay from "../components/GrainOverlay";

export default function About() {
  useEffect(() => {
    document.title = "About | GoneSoon";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="about-page" className="relative">
      <GrainOverlay />
      <div className="bg-coral">
        <Nav variant="coral" />
      </div>

      <section className="bg-coral text-white">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-24 md:pb-32">
          <div className="pill text-white border-white/60 mb-10">
            <span className="pill-dot" />
            About the club
          </div>
          <h1
            data-testid="about-headline"
            className="h-display text-white text-[3rem] md:text-[7rem] leading-[0.92] max-w-[15ch]"
          >
            A private club for better local prices.
          </h1>
        </div>
      </section>

      <section className="bg-cream text-ink">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10 py-24 md:py-36">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-4">
              <div className="text-xs uppercase tracking-[0.22em] text-ink/50">
                Our ethos
              </div>
            </div>
            <div className="md:col-span-8 space-y-8 text-lg leading-relaxed text-ink/80">
              <p>
                GoneSoon is a private local savings club created for people who enjoy discovering good places around their city.
              </p>
              <p>
                We work with selected cafés, restaurants, experiences, services and local businesses to create exclusive prices available through limited drops.
              </p>
              <p>
                These drops are not designed to stay forever. They may be limited by time, quantity or availability.
              </p>
              <p className="text-ink">
                GoneSoon is launching first in Trivandrum, with early access opening in small batches.
              </p>
            </div>
          </div>

          <div className="mt-16 pt-10 border-t border-ink/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <p className="text-xs uppercase tracking-[0.22em] text-ink/50">
              Ready to be considered?
            </p>
            <Link
              to="/#waitlist"
              data-testid="about-cta"
              className="btn-primary"
            >
              Request early access
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
